import { IProjectPropertyEncumbrance } from '~/@api/generated-api-types-project/Api'

const projectEncumberanceLabel: Record<IProjectPropertyEncumbrance, string> = {
  [IProjectPropertyEncumbrance.WithEncumbrance]: 'S ťarchou',
  [IProjectPropertyEncumbrance.WithEncumbrances]: 'S ťarchami',
  [IProjectPropertyEncumbrance.WithoutEncumbrance]: 'Bez tiarch',
}

// null z BO (nevybraté) = Bez tiarch, rovnako ako doteraz
function getProjectEncumberanceLabel(
  encumberance: IProjectPropertyEncumbrance
) {
  return (
    projectEncumberanceLabel[encumberance] ??
    projectEncumberanceLabel[IProjectPropertyEncumbrance.WithoutEncumbrance]
  )
}

export { getProjectEncumberanceLabel }
